document.addEventListener("turbo:load", () => {
  console.log("✅ C U S T O M E R   A U T O C O M P L E T E   L A U N C H");

  const input = document.getElementById("customerSearchInput");

  // ★ input が null であれば、ここで処理を終了する ★
  if (!input) {
    console.warn("⚠️ Warning: customerSearchInput element not found. Drawer might not be rendered.");
    return; // input が見つからない場合はここで処理を中断
  }

  const resultsContainer = document.getElementById("customerSearchResults");
  const shopId = input?.dataset.shopId;

  const record_id = input?.dataset.recordId;
  const record_type = input?.dataset.recordType;
  const autocompleteUrl = input.dataset.url; // HTMLのdata-url属性から取得

  if (!input || !resultsContainer || !shopId || !record_id || !record_type || !autocompleteUrl) {
    console.warn("⚠️ Error : Not Enough Parameters in Autocomplete");
    return;
  }

  let timer;

  input.addEventListener("input", () => {
    clearTimeout(timer);

    const query = input.value.trim();
    if (query.length === 0) {
      resultsContainer.innerHTML = "";
      return;
    }

    const locale = input.dataset.locale;
    timer = setTimeout(() => {
      const urlWithParams = `${autocompleteUrl}?r=${record_id}&q=${encodeURIComponent(query)}&record_type=${record_type}&locale=${locale}`;
      fetch(urlWithParams, {
        headers: { "Accept": "text/vnd.turbo-stream.html" },
      })
        .then(response => response.text())
        .then(html => {
          Turbo.renderStreamMessage(html);
        })
        .catch(() => {
          resultsContainer.innerHTML = "<p class='text-danger'>⚠️ Network Error</p>";
        });
    }, 300);
  });
});
